// COMPONENTS
import { TrackingForm } from "../../../components/pages/TrackingForm";

export const CreateTracking = () => <TrackingForm />;
